<template>

  <div class="about" v-if="!isMobile">
    <div class="left-content">
      <label style="font-size:28px;color:#301E03;padding: 10px 32px;">關於總會</label>
      <label v-for="(item, index) in aboutList" :key="index" :class="['left-item', { leftactive: curItem == index }]"
        @click=choose(index)>{{ item.title }}
      </label>
    </div>
    <div class="right-content">
      <div v-html="curData"></div>
    </div>
  </div>


  <div v-else class="about-mobile">
    <div class="news-title-mobile">
      <label class="news-msg-mobile">關於總會</label>
    </div>

    <el-menu background-color="#EFE9E0" :default-active="curItem+''" text-color="#301E03" active-text-color="#A05200"
      class="el-menu-demo" mode="horizontal" @select="choose">
      <el-menu-item v-for="(item, index) in aboutList" :key="index" :index="index+''">{{ item.title }}</el-menu-item>
    </el-menu>

    <div class="right-content-mobile">
      <div v-html="curData"></div>
    </div>

  </div>

</template>


<script>

export default {
  name: 'About',
  data() {
    return {
      curItem: 0,
      aboutList: [],
      curData: "",
      isMobile: false
    }
  },

  created() {
    this.isMobile = window.isMobile
  },
  mounted() {
    var that = this;

    this.$axios.get("article/lists", { params: { cateId: "10" } }).then(function (response) {
      that.aboutList = response.data.data
      that.curData = that.aboutList[0].content


      that.curData = that.curData.replace(/<img[^>]*>/gi, function (match) {

          if (match.indexOf('style') < 0) {
            match =match.replace(/<\s*img/, '<img style="max-width:100%;"').replace(/(width="(.*?)")|(height="(.*?)")/ig, '');
            } else {
              match =match.replace(/(width="(.*?)")|(height="(.*?)")|(width:(.*?);)|(height:(.*?);)/ig, '').replace(/style=("|')/, 'style=$1max-width:100%;')
            }
          return match;
      });


    }, function (err) {
      console.log('errerrerrerrerr ' + err);
    });


  },
  methods: {
    choose(index) {
      this.curItem = index;
      this.curData = this.aboutList[index].content;

      this.curData = this.curData.replace(/<img[^>]*>/gi, function (match) {

          if (match.indexOf('style') < 0) {
            match =match.replace(/<\s*img/, '<img style="max-width:100%;"').replace(/(width='(.*?)')|(height='(.*?)')/ig, '');
            } else {
              match =match.replace(/(width='(.*?)')|(height='(.*?)')|(width:(.*?);)|(height:(.*?);)/ig, '').replace(/style=("|')/, 'style=$1max-width:100%;')
            }
          return match;
      });

    }
  },
}
</script>


<style lang="scss" rel="stylesheet/scss" scoped>
.about {
  padding: 30px 0px 88px 0px;
  justify-content: center;
  width: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: flex-start;

  .left-content {
    justify-content: space-evenly;
    display: flex;
    flex-direction: column;
    width: 208px;
    height: 328px;
    background-color: #D9C8AD;


    .left-item {
      cursor: pointer;
      font-size: 18px;
      color: #301E03;
      padding-left: 32px;
      height: 54px;
      line-height: 54px;
    }

    .leftactive {
      background-color: #F2E7D5;
      color: #A05200;
    }
  }




  .right-content {
    overflow: hidden;
    padding: 48px;
    background-color: white;
    width: 812px;
    margin-left: 20px;
    min-height: 828px;
  }

}

.about-mobile {
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .el-menu-demo {
    ::v-deep .el-menu-item {
      width: 25%;
      text-align: center;
    }
  }

  .news-title-mobile {
    box-sizing: border-box;
    padding-left: 20px;
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;

    .news-msg-mobile {
      font-size: 22px;
      color: #301E03
    }
  }

  .right-content-mobile {
    min-height: 450px;
    padding: 18px;
    background-color: white;
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
